import apiClient from './configServices'
import NProgress from 'nprogress'

apiClient.interceptors.request.use(config => {
  NProgress.start()
  return config
})
apiClient.interceptors.response.use(response => {
  NProgress.done(true)
  return response
})

export default {
  postUser(user) {
    return apiClient.post('/users/auth', user)
  },
  postPasswordReset(user) {
    return apiClient.post('/users/reset-password', user)
  }
}
